import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FaSearch, FaBars, FaTimes, FaCaretDown } from "react-icons/fa";
import { PROFILES, grad } from "./Netflix";

const LINKS = [["/", "Home", true], ["/projects", "Projects"], ["/contact", "Contact"]];
const SUGGEST = ["React", "Python", "Android", "MongoDB"];

export default function Navbar({ profile, onPick, onSwitch }) {
  const [solid, setSolid] = useState(false);
  const [menu, setMenu] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const [sOpen, setSOpen] = useState(false);
  const [q, setQ] = useState("");
  const [foc, setFoc] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();
  const inp = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setDrawer(false); setMenu(false); }, [loc.pathname]);
  useEffect(() => { setQ(new URLSearchParams(loc.search).get("q") || ""); }, [loc.search]);
  useEffect(() => { if (sOpen && inp.current) inp.current.focus(); }, [sOpen]);

  /* press "/" anywhere (outside a text field) to open search */
  useEffect(() => {
    const k = e => {
      if (e.key !== "/" || e.ctrlKey || e.metaKey || e.altKey) return;
      const t = e.target;
      const tag = t && t.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || (t && t.isContentEditable)) return;
      e.preventDefault();
      setSOpen(true);
    };
    document.addEventListener("keydown", k);
    return () => document.removeEventListener("keydown", k);
  }, []);

  useEffect(() => {
    if (!menu) return;
    const h = e => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenu(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [menu]);

  const search = v => {
    setQ(v);
    nav(v.trim() ? `/projects?q=${encodeURIComponent(v)}` : "/projects", { replace: loc.pathname === "/projects" });
  };
  const searchOpen = sOpen || q;

  return (
    <nav className={`nx-nav${solid ? " nx-solid" : ""}`} aria-label="Main">
      <button className="nx-burger" aria-label="Open menu" onClick={() => setDrawer(true)}><FaBars /></button>
      <NavLink to="/" className="nx-logo">AAYAM</NavLink>

      <ul>
        {LINKS.map(([to, label, end]) => (
          <li key={to}><NavLink to={to} end={end} className={({ isActive }) => `nx-link${isActive ? " on" : ""}`}>{label}</NavLink></li>
        ))}
      </ul>

      <div className={`nx-search${searchOpen ? " open" : ""}${foc ? " foc" : ""}`} role="search">
        <button type="button" aria-label="Search projects and skills" onClick={() => setSOpen(true)}><FaSearch /></button>
        <input ref={inp} value={q} placeholder="Projects, skills, tech" aria-label="Search"
          onChange={e => search(e.target.value)}
          onFocus={() => setFoc(true)}
          onBlur={() => { setFoc(false); if (!q) setSOpen(false); }}
          onKeyDown={e => { if (e.key === "Escape") { search(""); setSOpen(false); e.target.blur(); } }} />
        {q
          ? <button type="button" className="nx-sclr" aria-label="Clear search"
              onMouseDown={e => e.preventDefault()}
              onClick={() => { search(""); if (inp.current) inp.current.focus(); }}><FaTimes /></button>
          : <kbd className="nx-kbd" aria-hidden="true">/</kbd>}
        {foc && !q && (
          <div className="nx-sug" onMouseDown={e => e.preventDefault()}>
            <p>Popular searches</p>
            <div>
              {SUGGEST.map(s => <button key={s} type="button" onClick={() => search(s)}>{s}</button>)}
            </div>
          </div>
        )}
      </div>

      <div className="nx-pm" ref={menuRef}>
        <button className="nx-me" aria-haspopup="menu" aria-expanded={menu} aria-label="Profile menu" onClick={() => setMenu(m => !m)}>
          <span className="nx-mini" style={{ background: grad(profile) }}><profile.icon /></span>
          <FaCaretDown />
        </button>
        {menu && (
          <div className="nx-menu" role="menu">
            {PROFILES.filter(p => p.id !== profile.id).map(p => (
              <button key={p.id} role="menuitem" onClick={() => { onPick(p); setMenu(false); }}>
                <span className="nx-mini" style={{ background: grad(p) }}><p.icon /></span>{p.name}
              </button>
            ))}
            <hr />
            <button role="menuitem" onClick={onSwitch}>Switch profile screen</button>
            <a role="menuitem" href="/Aayam_Bhattarai_CV.pdf" download="Aayam_Bhattarai_CV.pdf">Download CV</a>
          </div>
        )}
      </div>

      {drawer && (
        <div className="nx-drawer-bg" onClick={() => setDrawer(false)}>
          <aside className="nx-drawer" onClick={e => e.stopPropagation()} aria-label="Menu">
            <button className="nx-x" aria-label="Close menu" onClick={() => setDrawer(false)}><FaTimes /></button>
            <span className="nx-logo">AAYAM</span>
            {LINKS.map(([to, label, end]) => (
              <NavLink key={to} to={to} end={end} className={({ isActive }) => `nx-dlink${isActive ? " on" : ""}`}>{label}</NavLink>
            ))}
            <a className="nx-dlink" href="/Aayam_Bhattarai_CV.pdf" download="Aayam_Bhattarai_CV.pdf">Download CV</a>
          </aside>
        </div>
      )}
    </nav>
  );
}
